
//initial state
const state = {
	refreshOrder:false,
	listParam:{}
}

const getters = {// 由state派生一些状态，类似组件里的computed
		
	
}

const actions = {//提交mutation,不能直接更改state,可以进行异步操作
	refreshOrderList({commit},bool){
		commit('toRefreshOrder',bool)
	},
	getOrderList({commit},obj){
		commit('rescueOrderList',obj)
	}
}

const mutations = {//直接改变state, 必须是同步操作 ---- type(state){//handler回调函数   }
	toRefreshOrder(state,bool){
		state.refreshOrder = bool
	},
	rescueOrderList(state,obj){
		state.listParam = obj
	}
}
export default{
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/rescue.js